<template>
  <div>
    <custom-callout
      class="mb-3 custom-callout"
      :opened="isPanelOpen"
      :controlled="true"
      @click:open="onToggle()"
    >
      <div class="row py-3">
        <div class="col-md-2 col-12 col-spacing mb-3 mb-lg-0">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Estatus:
          </div>
          <div class="color-black font-16 font-weight-normal text-break">
            <custom-balloon
              :background-color="getStatus.statusColor"
              class="mt-2"
              :text="getStatus.statusName"
              dot
            />
          </div>
        </div>
        <div class="col-md-2 col-12 col-spacing mb-3 mb-lg-0">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Nombre de Materiales/Equipos:
          </div>
          <div class="color-black font-16 font-weight-normal text-break">
            {{ item.title | empty }}
          </div>
        </div>
        <div class="col-md-2 col-12 col-spacing mb-3 mb-lg-0">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Cantidad en Inventario:
          </div>
          <div class="color-black font-16 font-weight-normal text-break">
            {{ item.quantity | empty }}
          </div>
        </div>
        <div class="col-md-2 col-12 col-spacing mb-3 mb-lg-0">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Disponible en Inventario:
          </div>
          <div class="color-black font-16 font-weight-normal text-break">
            {{ availableQuantity }}
          </div>
        </div>
        <div class="col-md-2 col-12 col-spacing mb-3 mb-lg-0">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Última Fecha de Inventario:
          </div>
          <div class="color-black font-16 font-weight-normal text-break">
            {{ item.lastDate | date }}
          </div>
        </div>
        <div class="col">
          <drop-down
            always-show-dropdown
            :items="actionItems"
            class="float-md-right mr-5"
          />
        </div>
      </div>
      <div class="col-12 border-bottom"></div>
      <div class="row py-3">
        <div class="col-md-2 col-12 col-spacing mb-3 mb-lg-0">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Tipo de Salón::
          </div>
          <div class="color-black font-16 font-weight-normal text-break">
            {{ item.saloon | empty }}
          </div>
        </div>
        <div class="col-md-2 col-12 col-spacing mb-3 mb-lg-0">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Centro:
          </div>
          <div class="color-black font-16 font-weight-normal text-break">
            {{ item.caat | empty }}
          </div>
        </div>
        <div class="col-md col-12 col-spacing mb-3 mb-lg-0">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Escuela:
          </div>
          <div class="color-black font-16 font-weight-normal text-break">
            {{ item.school | empty }}
          </div>
        </div>
      </div>
      <template #edition>
        <div v-if="showAdditionalInfo" class="px-3 py-4">
          <div class="bg-white px-4 py-2 rounded">
            <custom-tab
              no-nav-style
              nav-class="mb-4 mx-0 w-100"
              :default-active-tab="activeTab"
            >
              <custom-tab-item
                title="Información Adicional"
                nav-item-class="text-center"
                nav-link-class="fs-17"
              >
                <additional-info class="px-1" :item="item" />
              </custom-tab-item>
            </custom-tab>
          </div>
        </div>
      </template>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';
import CustomBalloon from 'custom-balloon';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';
import PROPERTIES from '@/utils/constants/inventory/bookItemProperties';
import { CustomTab, CustomTabItem } from 'custom-tabs';
import AdditionalInfo from './AdditionalInfo.vue';

const TEMPLATE_TAB_INDEX = {
  EQUIPMENTINFO: 1,
  TRANSFER: 2,
};
const TAB_ITEMS = {
  INFO: 0,
};
export default {
  name: 'ResultRowSummary',
  components: {
    CustomCallout,
    DropDown,
    CustomBalloon,
    CustomTab,
    CustomTabItem,
    AdditionalInfo,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeTab: TAB_ITEMS.INFO,
      selectedTemplateTabIndex: null,
      accesories: [],
    };
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
    availableQuantity() {
      return this.item.quantity - this.item.assignedQuantity;
    },
    getStatus() {
      return this.availableQuantity > 0
        ? { statusColor: '#A3E5B3', statusName: 'Disponible' }
        : { statusColor: '#D5B89A', statusName: 'No Disponible' };
    },
    actionItems() {
      return [
        {
          name: 'Ver Información Adicional',
          icon: 'fas fa-info-circle text-green',
          click: () => {
            this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.EQUIPMENTINFO;
            this.activeTab = TAB_ITEMS.INFO;
            this.$emit('open', this.item);
          },
        },
        {
          name: 'Agregar Inventario',
          icon: 'fas fa-edit text-green',
          click: () => {
            this.$router.push({
              name: 'inventory-catalog-books-add',
              params: {
                id: this.catalogId,
                bookId: this.item.id,
              },
            });
          },
        },
      ];
    },
    isPanelOpen() {
      return this.item.isOpen;
    },
    catalogId() {
      return this.$route.params.id;
    },
    readingMedium() {
      return this.item.properties?.find(
        (x) => x.name === PROPERTIES.ReadingMedium
      );
    },
    showAdditionalInfo() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.EQUIPMENTINFO;
    },
    showTransfer() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.TRANSFER;
    },
  },
  methods: {
    onToggle() {
      this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.EQUIPMENTINFO;

      if (this.item.isOpen) {
        this.$emit('close', this.item);
        return;
      }

      this.$emit('open', this.item);
    },
  },
};
</script>
<style lang="scss" scoped>
.gap-y-2 {
  gap: 20px 0px;
}

.bg-white {
  ::v-deep div.bg-secondary-3 {
    background-color: white !important;
  }
}

::v-deep .dot {
  padding: 18px !important;
  margin-bottom: 1px;
}

::v-deep .title-icon {
  padding-bottom: 3px;
}
.custom-tab {
  --tab-active-color: #ff7058 !important;
}
::v-deep .fs-17 {
  font-size: 17px !important;
}
</style>
